export function drawSvgLine() {
  $(".scene-evidence svg").css("opacity", 1);
  const connections = [
    [1, 3],
    [1, 2],
    [3, 2],
    [3, 4],
    [2, 4],
    [2, 6],
    [2, 8],
    [4, 5],
    [4, 7],
    [6, 8],
    [6, 9],
    [7, 8],
    [7, 9],
    [8, 10],
    [9, 10],
  ];

  const container = document.querySelector(".scene-evidence--wrapper");
  const svg = container.querySelector("svg");
  if (!container || !svg) return;

  svg.querySelector(".rope-group")?.remove();

  const containerRect = container.getBoundingClientRect();
  const ropeGroup = document.createElementNS("http://www.w3.org/2000/svg", "g");
  ropeGroup.classList.add("rope-group");

  let delay = 0;

  connections.forEach(([a, b], index) => {
    const pinA = container.querySelector(`.img-ev__container--hidden .img-ev__pin--hidden[data-pin="${a}"]`);
    const pinB = container.querySelector(`.img-ev__container--hidden .img-ev__pin--hidden[data-pin="${b}"]`);
    if (!pinA || !pinB) return;

    const rectA = pinA.getBoundingClientRect();
    const rectB = pinB.getBoundingClientRect();

    const offsetAX = parseFloat(pinA.dataset.offsetX || 0);
    const offsetAY = parseFloat(pinA.dataset.offsetY || 0);
    const offsetBX = parseFloat(pinB.dataset.offsetX || 0);
    const offsetBY = parseFloat(pinB.dataset.offsetY || 0);

    const x1 = rectA.left + rectA.width / 2 - containerRect.left + offsetAX;
    const y1 = rectA.top + rectA.height - containerRect.top + offsetAY;
    const x2 = rectB.left + rectB.width / 2 - containerRect.left + offsetBX;
    const y2 = rectB.top + rectB.height - containerRect.top + offsetBY;

    const length = Math.hypot(x2 - x1, y2 - y1);

    const line = document.createElementNS("http://www.w3.org/2000/svg", "line");
    line.setAttribute("x1", x1);
    line.setAttribute("y1", y1);
    line.setAttribute("x2", x2);
    line.setAttribute("y2", y2);
    line.setAttribute("stroke", "#d43b3b");
    line.setAttribute("stroke-width", "2");
    line.setAttribute("stroke-linecap", "round");

    // Setup for stroke animation
    line.setAttribute("stroke-dasharray", length);
    line.setAttribute("stroke-dashoffset", length);
    line.style.transition = `stroke-dashoffset 0.2s ease ${delay}s`;
    requestAnimationFrame(() => {
      line.setAttribute("stroke-dashoffset", "0");
    });

    delay += 0.1; // Delay between each line appearing

    ropeGroup.appendChild(line);
  });

  svg.appendChild(ropeGroup);
}
